import { Component, OnInit } from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event} from "@angular/router";
import { Location } from '@angular/common';

@Component({
    selector: 'app-progress-bar-request',
    templateUrl: './progress-bar-request.component.html',
    styleUrls: ['./progress-bar-request.component.scss'],
    standalone: false
})
export class ProgressBarRequestComponent implements OnInit {

    progressValue = 0;
    progressColor = 'primary';

    progressTimer: any;

    stopProgress = false;

    constructor(
        private router: Router,
        private location: Location
    ) {
        this.router.events.subscribe((event: Event) => {
            this.navigationObserver(event);
        });
    }

    ngOnInit(): void {
    }

    private navigationObserver(event: Event): void {
        if (event instanceof NavigationStart) {
            this.progressValue = 0;
            this.stopProgress = false;
            this.progressTimer = setInterval(() => {
                this.loading();
            }, 25);
        }

        if (event instanceof NavigationEnd) {
            // When the navigation finishes, quickly complete and hide the bar
            this.progressValue = 100;
            this.stopProgress = true;
            clearInterval(this.progressTimer);
            // Hide the progress bar after a short delay
            setTimeout(() => {
                this.progressValue = 0;
            }, 200);
        }

        if (event instanceof NavigationCancel) {
            this.progressValue = 0;
            this.stopProgress = true;
            clearInterval(this.progressTimer);
            // Update the browser URL state when navigation is cancelled
            const currentUrl = this.router.url;
            this.location.replaceState(currentUrl, '', { navigationId: this.router.getCurrentNavigation()?.id });
        }

        if (event instanceof NavigationError) {
            this.progressValue = 0;
            this.stopProgress = true;
            clearInterval(this.progressTimer);
        }
    }

    // Function to increase the value of the progress bar
    private loading(): void {
        if (this.progressValue >= 95 || this.stopProgress) {
            clearInterval(this.progressTimer);
        } else {
            this.progressValue++;
        }
    }
}
